import { makeStyles } from '@material-ui/core/styles'
import theme, { themeCommon } from '../../../styles/theme';

const useStyles = makeStyles((theme) => ({
    rootDialog: {
        fontFamily: themeCommon.RobotoRegular,
    },
    rootPaperWidthFalse: {
        width: '500px',
        [theme.breakpoints.down('lg')]: {
            width: '45%'
        },
        [theme.breakpoints.down('md')]: {
            width: '60%'
        },
        [theme.breakpoints.down('sm')]: {
            width: '90%'
        },
    },
    rootDialogTitle: {
        background: themeCommon.lightBlue,
        color: '#FFFFFF',
        textAlign: 'center',
        fontSize: themeCommon.fontSize16px,
        fontFamily: themeCommon.RobotoBold,
        padding: '10px 0',
    },
    rootDialogActions: {
        justifyContent: 'center',
    },
    rootButtonAgree: {
        borderRadius: '5px',
        width: '150px',
        height: '30px',
        border: `1px solid ${themeCommon.lightBlue}`,
        color: themeCommon.lightBlue,
        '&:hover': {
            background: '#FFFFFF',
        },
    },
    rootGrid: {
        // '& > div': {
        //     margin: '0 5px',
        // },
    },
    containerImageUser: {
        width: '100px',
        height: '100px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft : 'auto',
        marginRight : 'auto',
        [theme.breakpoints.down('sm')]: {
            width: '90px',
            height: '90px',
        },
        [theme.breakpoints.down('xs')]: {
            width: '80px',
            height: '80px',
        },
        '@media (max-width: 350px)': {
            width: '70px',
            height: '70px',
        },
        '& > img': {
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            border: '0.5px solid #0492C2',
            objectFit: 'contain',
        }
    },
    textContent: {
        paddingLeft: '5px',
        fontSize: themeCommon.fontSize14px,
        fontFamily: themeCommon.RobotoBold,
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize12px,
        },
    },
    rootGridContent: {
        margin: '10px 0 0',
    },
    code: {
        fontSize: themeCommon.fontSize18px,
        margin: '0 0 15px',
    },
    codeSuccess: {
        color: '#46AA42',
    },
    codeFail: {
        color: '#DA2A1C',
    },
    titleContent: {
        fontSize: themeCommon.fontSize20px,
        fontFamily: themeCommon.RobotoBold,
        margin: '5px 0 15px',
        paddingLeft: '5px',
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize16px
        }
    },
    message: {
        fontSize: themeCommon.fontSize14px,
        margin: '5px 0 15px',
        textAlign: 'center',
    },
}), {
    name: 'DialogLearningContentHeadContainer',
    index: 1,
})

export default useStyles